import React from 'react'
import { Link } from 'gatsby'
import classNames from 'classnames'
import counterClasses from 'src/components/Counter/Counter.module.scss'
import { themeColors } from 'training-lane-booking-shared/utilities/constants'

const BackToBookingButton = ({ buttonStyles, isXSmall = false }) => (
    <button
        className={classNames(
            counterClasses.bcButton,
            {
                [counterClasses.hvrRippleOut]: !isXSmall,
                [counterClasses.hvrRippleOutBackButton]: !isXSmall
            }
        )}
        style={{
            zIndex: 1,
            ...buttonStyles
        }}
    >
        <Link
            to="/booking"
            style={{ color: themeColors[isXSmall ? 'brandBlue' : 'brandRed'] }}>
            &lt;
            {
                isXSmall ? (
                    <div className={counterClasses.backText}> Back</div>
                ) : null
            }
        </Link>
    </button>
)

export default BackToBookingButton
